module.exports = __webpack_public_path__ + "img/81.bf38cdee.jpg";